import React from 'react';
import AwardSummaryCard from './components/AwardSummaryIndex.jsx';

const AwardSummary = () => <AwardSummaryCard />;

export default AwardSummary;
